import { 
  ref, 
  get, 
  push,
  remove,
  update,
  serverTimestamp,
  child,
  set
} from 'firebase/database';
import { TableQR, TableQRInput } from '../types/qr';
import { database } from '../config/firebase';

// Re-export the TableQR type
export type { TableQR };

export const saveTableQR = async (table: TableQRInput): Promise<void> => {
  try {
    const tablesRef = ref(database, 'tables');
    const newTableRef = push(tablesRef);
    
    await set(newTableRef, {
      ...table,
      id: newTableRef.key,
      createdAt: serverTimestamp(),
      lastUpdated: serverTimestamp()
    });
  } catch (error) {
    console.error('Error saving table:', error);
    throw error;
  }
};

export const updateTableQR = async (id: string, updates: Partial<TableQRInput>): Promise<void> => {
  try {
    const tableRef = ref(database, `tables/${id}`);
    
    await update(tableRef, {
      ...updates,
      lastUpdated: serverTimestamp()
    });
  } catch (error) {
    console.error('Error updating table:', error);
    throw error;
  }
};

export const deleteTableQR = async (id: string) => {
  try {
    const tableRef = child(ref(database, 'tables'), id);
    await remove(tableRef);
  } catch (error) {
    console.error('Error deleting table QR:', error);
    throw error;
  }
};

export const getAllTables = async () => {
  try {
    const tablesRef = ref(database, 'tables');
    const snapshot = await get(tablesRef);
    const tables: TableQR[] = [];
    
    snapshot.forEach((child) => {
      const tableData = child.val() as Omit<TableQR, 'id'>;
      tables.push({
        ...tableData,
        id: child.key || ''
      });
    });
    
    return tables;
  } catch (error) {
    console.error('Error getting tables:', error);
    throw error;
  }
};